import { css } from 'linaria'
import theme, {
  COLORS, ROUNDED,
} from '../../styles/theme'
import commonStyling from '../../styles/commonStyling'

export const imageSizes = Object.freeze({
  desktop: {
    width: 368,
    height: 210,
  },
  tablet: {
    width: 368,
    height: 210,
  },
  mobile: {
    width: 343,
    height: 184,
  },
})

const classes = {
  bodyText: css`
    &.MuiTypography-body1 {
      text-align: center;
      color: ${COLORS.bodyTextPrimary};
      font-weight: ${theme.typography.fontWeightLight!};
      margin: auto;
      margin-bottom: ${theme.spacing(4)}px;
      p {
        margin: 0;
      }
    }
  `,
  section: css`
    padding: ${theme.spacing(0, 2)};
  `,
  title: css`
    color: ${theme.palette.primary.main};
    text-align: center;
    &.MuiTypography-root {
      margin-bottom: ${theme.spacing(4)}px;
      ${theme.breakpoints.up('md')} {
        margin-bottom: ${theme.spacing(4)}px;
      }
    }
  `,
  outerCard: css`
  box-sizing: content-box;
  border-radius: ${ROUNDED.medium}px;
  border: 1px solid ${COLORS.gray3};
  justify-content: center;
    p {
      margin: 0;
    }
    &.MuiGrid-root {
      display: flex;
      &:first-child {
        margin-top: 0;
      }
    }
    &.MuiGrid-item {
      padding: ${theme.spacing(1, 2)};
    }
  `,
  innerCard: css`
    min-height: 100%;
    box-shadow: ${commonStyling.boxShadowLight};
    text-align: center;
    border-radius: ${commonStyling.roundedBorders.all};
    overflow: hidden;
    max-width: ${commonStyling.imageCardMaxWidth};

    &.MuiGrid-root {
      flex-wrap: nowrap;
    }
  `,
  imageContainer: css`
    margin: 0 auto;
    width: 100%;
    height: auto;
    background-color: white;
    position: relative;
    overflow: hidden;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  `,
  cardCenter: css`
    &.MuiGrid-root {
      justify-content: center !important;
    }
  `,
  cardClick: css`
    cursor: pointer;
  `,
  noButton: css`
    &.MuiTypography-root {
      padding-bottom: ${theme.spacing(4)}px;
    }
  `,
  availability: css`
    border-radius: ${commonStyling.roundedBorders.all};
    color: white;
    position: absolute;
    top: 18px;
    right: 15px;
    padding: ${theme.spacing(1, 2)};
    text-transform: uppercase;
  `,
  bgPrimary: css`
    background-color: ${theme.palette.primary.main};
  `,
  bgSecondary: css`
    background-color: ${theme.palette.secondary.main};
  `,
  loadMoreBtn: css`
    outline: none;
    border: none;
    background-color: transparent;
    cursor: pointer;
  `,
  loadMoreContainer: css`
    margin-top: ${theme.spacing(5)}px;
  `,
  iconPadding: css`
    padding-top: 2px;
  `,
  loadMoreBtnText: css`
    display: flex;
    justify-content: center;
    align-items: center;
    
    ${theme.breakpoints.up('md')} {
      &:hover {
        text-decoration: underline;
      }
    }
  `,
}

export default classes
